import { useTranslation } from 'react-i18next';
import {
  Badge,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  HStack,
  Stack,
  StatusBadge,
  Text,
} from '@shared/ui';

export function BadgeShowcase() {
  const { t } = useTranslation();
  const tones = ['positive', 'neutral', 'warning', 'negative', 'informational'] as const;
  const appearances = ['soft', 'solid', 'outline'] as const;

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.feedback.badge.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.feedback.badge.description')}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <HStack gap="sm" className="flex-wrap">
          <Badge appearance="soft">{t('uiLibrary.feedback.badge.variants.soft')}</Badge>
          <Badge appearance="solid">{t('uiLibrary.feedback.badge.variants.solid')}</Badge>
          <Badge appearance="outline">{t('uiLibrary.feedback.badge.variants.outline')}</Badge>
        </HStack>
        <div className="space-y-2">
          <Text size="sm" className="font-medium">
            {t('uiLibrary.feedback.badge.semantic.title')}
          </Text>
          <Stack gap="sm" data-testid="semantic-badge-matrix">
            {appearances.map((appearance) => (
              <HStack key={appearance} gap="sm" className="flex-wrap">
                {tones.map((tone) => (
                  <StatusBadge key={tone} appearance={appearance} tone={tone}>
                    {t(`uiLibrary.feedback.badge.semantic.${tone}`)} ·{' '}
                    {t(`uiLibrary.feedback.badge.variants.${appearance}`)}
                  </StatusBadge>
                ))}
              </HStack>
            ))}
          </Stack>
        </div>
      </CardContent>
    </Card>
  );
}
